import { useScriptMetaPixel, useScriptGoogleAnalytics, useScriptGoogleTagManager, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-WQ7TPDR9"})
    const googleAnalytics = useScriptGoogleAnalytics({"id":"G-HSK8F6628D"})
    const metaPixel = useScriptMetaPixel({"id":"2212080132630179"})
    return { provide: { $scripts: { googleTagManager, googleAnalytics, metaPixel } } }
  }
})